// extracted by mini-css-extract-plugin
export default {"verified":"FLNmk","icon":"irue9"};